<template>
    <div>
        <md-field>
            <md-textarea v-model="rawImportData"></md-textarea>
        </md-field>
        <md-button @click="caseImport()" class="md-primary md-raised">
            Import Case
        </md-button>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    export default {
        data: function(){
            return {
                rawImportData: ""
            }
        },
        methods: {
            caseImport: function(){
                try {
                    var importData = JSON.parse(this.rawImportData)
                }
                catch(e){
                    alert("Cannot import case: invalid JSON data!")
                    return
                }
                if(importData.id){
                    APIRequests.postJSONData(
                        this.$store.state.api_url + "/api/editor/importCase", 
                        importData,
                        this.$store.state.jwtToken
                    ).then(() => {
                        alert("Imported to DB successfully!")
                        this.$router.push("/cases/" + importData.id) 
                    }).catch(([xhrStatus, xhrResp]) => {
                        alert("Error, failed to import: " + xhrStatus + " - " + xhrResp)
                    })
                }
            }
        }
    }
</script>